import {ReactElement} from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import User from 'interfaces/User';
import FlexBox from 'shared/components/ui/FlexBox';
import Menu from './components/Menu';
import useStyles from './useStyles';

type Props = {
  onClickHamburger: () => void;
  user: User;
  isDoctor: boolean;
  doctorIsAdmin: boolean;
};

function HeaderView({onClickHamburger, user, isDoctor, doctorIsAdmin}: Props): ReactElement {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Grid container alignItems="center">
        <Hidden smUp>
          <Grid item xs={1}>
            <ButtonBase onClick={onClickHamburger}>
              <MenuIcon />
            </ButtonBase>
          </Grid>
        </Hidden>
        <Grid item sm={12} xs={11}>
          <FlexBox justifyContent="flex-end">
            <Menu fullname={user.fullname} isDoctor={isDoctor} doctorIsAdmin={doctorIsAdmin} />
          </FlexBox>
        </Grid>
      </Grid>
    </div>
  );
}

export default HeaderView;
